<template>
    <div class="d-flex content-header-plano-massmarket">
        <div class="col-1"><button class="btnExp bt-save pointer" @click="cancelPlano">Cancel</button></div>
        <div class="col-3 content-info-user">
            <div>{{ $t("planobuilder.by") }} {{ createBy.firstname ? createBy.firstname : "" }} {{ createBy.lastname }}</div>
            <div>
                {{ $t("planobuilder.modifiedBy") }} {{ modifyBy.firstname }} {{ modifyBy.lastname }} {{ $t("planobuilder.on") }} {{ modifyBy.date }}
            </div>
        </div>
        <div class="col-7 content-header-title">
            <span>
                <div class="title">{{ planoDetails.name }}</div>
                <div class="campaignName uppercase m-txtLeft">
                    {{ planoDetails.campaign ? planoDetails.campaign.name : "" }} - {{ planoDetails.zone ? planoDetails.zone.name : "" }}
                </div>
            </span>
            <span @click="showModalEditName = true;"> <i class="fas fa-pencil-alt pointer"></i> </span>
        </div>
        <div v-show="!planoDetails.isLocked" class="col-1"><button class="btnExp bt-save pointer" @click="savePlano">Save</button></div>

        <EditPlanoName key="modal" v-if="showModalEditName" :currentPlanoName="planoDetails.name" @close="onEditNameClose" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import httpService from "../../service";
import EditPlanoName from "./EditNameModal.vue";

function savePlanoName(name, id) {
    httpService.post(`/plano/${id}`, JSON.stringify({ name }));
}

export default {
    components: {
        EditPlanoName
    },
    data() {
        return {
            showModalEditName: false,
            createBy: {},
            modifyBy: {}
        };
    },
    computed: {
        ...mapGetters("plano/data", {
            getPlanoDetails: "getPlanoDetails",
            getMeuble: "getMeuble"
        }),

        ...mapGetters("plano/status", {
            getMode: "getMode"
        }),

        ...mapGetters("planonext/plano", {
            getDividers: "getDividers",
            getGroups: "getGroups"
        })
    },
    created() {
        let planoDetails = this.getPlanoDetails;
        this.createBy = planoDetails.createdUser;
        // console.log(planoDetails.modifiedUser, '=====')
        this.modifyBy = {
            firstname: planoDetails.modifiedUser.firstname,
            lastname: planoDetails.modifiedUser.lastname,
            date: planoDetails.modifiedUser.modifiedDate
        };

        this.planoDetails = planoDetails;
    },
    methods: {
        onEditNameClose(newName) {
            this.showModalEditName = false;
            if (typeof newName === "string") {
                this.planoDetails.name = newName;
                savePlanoName(newName, this.planoDetails.id);
            }
        },
        ...mapActions("events/planomassmarket", {
            dispatchSavePlano: "dispatchSavePlano",
            dispatchSaveModuleEdit: "dispatchSaveModuleEdit",
            dispatchSaveShelfEdit: "dispatchSaveShelfEdit"
        }),

        ...mapActions("plano/status", {
            setMode: "setMode"
        }),

        cancelPlano() {
            if (this.getMode === "plano") {
                this.$router.replace("/planos");
            } else if (this.getMode === "module" || this.getMode === "shelf" || this.getMode === "caddy") {
                this.setMode("plano");
            }
        },

        savePlano() {
            if (this.getMode === "plano") {
                this.dispatchSavePlano({ save: true });
            } else if (this.getMode === "module") {
                this.dispatchSaveModuleEdit({ save: true });
            } else if (this.getMode === "shelf") {
                this.dispatchSaveShelfEdit({ save: true });
            } else if (this.getMode === "caddy") {
            }
            // TODO: save caddy fashias
        }
    }
};
</script>

<style scoped lang="scss">
.content-header-plano-massmarket {
    background-color: #000;
    /*height: 50px;*/
    color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;

    .content-header-title {
        display: flex;
        justify-content: center;
        align-items: center;

        > :last-child {
            margin-left: 10px;
        }

        div {
            text-align: center;
        }
    }

    .bt-save {
        color: white;
        border: 1px solid white;
        min-width: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// HeaderPlanoMassMarket.vue?6c0aab2e